import activityRedemption from './ActivityRedemption';
import auth from './Auth';
import bonusActivity from './BonusActivity';
import bonusRewardOrder from './BonusRewardOrder';
import bonusShop from './BonusShop';
import bonusTimeline from './BonusTimeline';
import dashboard from './Dashboard';
import feedback from './Feedback';
import loginAlerts from './LoginAlerts';
import notifications from './Notifications';
import profile from './Profile';
import registration from './Registration';
import tos from './TermsOfService';
import userInfo from './UserInfo';

export const sharedReducers = {
  activityRedemption,
  auth,
  bonusActivity,
  bonusRewardOrder,
  bonusShop,
  bonusTimeline,
  dashboard,
  feedback,
  loginAlerts,
  notifications,
  profile,
  registration,
  tos,
  userInfo,
};

export type SharedReducers = typeof sharedReducers;
